import { Moon, Sun } from "lucide-react"

import { useTheme } from "./theme-provider"
import { cn } from "@/lib/utils"

interface ThemeToggleProps {
    className?: string
    iconClassName?: string
}

export function ThemeToggle({ className, iconClassName }: ThemeToggleProps) {
    const { theme, setTheme } = useTheme()

    const toggleTheme = () => {
        setTheme(theme === "dark" ? "light" : "dark")
    }

    return (
        <button
            onClick={toggleTheme}
            className={cn(
                "relative inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 hover:bg-blue-500 hover:text-white dark:hover:bg-white/15 dark:hover:text-white h-9 w-9",
                className
            )}
            aria-label="Toggle theme"
        >
            <Sun className={cn("h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0", iconClassName)} />
            <Moon className={cn("absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100", iconClassName)} />
            <span className="sr-only">Toggle theme</span>
        </button>
    )
}
